module.exports = __webpack_public_path__ + "img/sequoia.bbebe88f.png";